<template>
  <b-row>
    <b-col cols="12">
      <SearchFilter :result.sync="result" :pagination.sync="pagination" />
    </b-col>
    <b-col cols="12" class="pt-4">
      <SearchResult :result="result" :pagination.sync="pagination" />
    </b-col>
  </b-row>
</template>

<script>
import SearchFilter from './_components/SearchFilter';
import SearchResult from './_components/SearchResult';
import { initialPagination } from './_utils';

import storeMixin from '@/mixin/storeGenerator';

export default {
  name: 'LocationAlternativesSearch',
  mixins: [storeMixin],
  components: {
    SearchFilter,
    SearchResult,
  },

  inject: ['layoutHeaderActions'],

  data() {
    return {
      result: [],
      pagination: initialPagination(),
    };
  },

  destroyed() {
    this.persistData();
  },
};
</script>
